module.exports = __webpack_public_path__ + "img/block_2.5a946367.webp";